import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

import {
  selectBrandState,
  selectUserBrandLoaded
} from '@amfam/shared/utility/brand/lib/+state/brand.selectors';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';
import { NavigationService } from '@amfam/shared/utility/navigation/lib/services/navigation.service';
import { ROUTE_PARAMS } from '@amfam/shared/utility/shared-services/lib/storage/storage-keys';

export const navigationResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const store = inject(Store);
  const router = inject(Router);
  const navigationService = inject(NavigationService);
  const featureFlagService = inject(FeatureFlagService);

  const waitForUserBrandToLoad = (): Observable<boolean> =>
    store.select(selectUserBrandLoaded).pipe(
      filter(loaded => loaded),
      take(1)
    );

  if (!featureFlagService.isEnabled('partner')) {
    return of(true);
  }
  const routeExperienceId = route.paramMap.get(ROUTE_PARAMS.EXPERIENCE_ID);
  return waitForUserBrandToLoad().pipe(
    switchMap(() => {
      const brand = store.selectSignal(selectBrandState)();
      if (!brand.isPartner && !routeExperienceId) {
        // no redirect for AFI
        return of(true);
      }
      let pathIndex = 2;
      if (!routeExperienceId) {
        pathIndex = 1;
      }
      if (brand.experienceId !== routeExperienceId && typeof routeExperienceId === 'number') {
        const url = state.url.split('/');
        const routeArray: string[] = [];
        for (let i = pathIndex; i < url.length; i++) {
          routeArray.push(url[i]?.split('?')[0] ?? '');
        }
        if (state.url !== '/' + routeArray.join('/') || brand.isPartner) {
          navigationService.navigate(
            routeArray,
            // keep the query params and state when fixing the URL for expId
            router.currentNavigation()?.extras
          );
        }
      }
      return of(true);
    })
  );
};
